module.exports = __webpack_public_path__ + "static/media/14d.e5a6703c.svg";